import { CircularProgress, Grid } from "@material-ui/core";
import React from "react";
import { MainView } from "../../modules/mainview";
import classes from "./index.module.scss";
import { LeftContentInvoicesList } from "./left-content";
import { RouteComponentProps } from "react-router-dom";
import { RigthContentInvoicesList } from "./rigth-content";
import { APSAPI } from "modules/uri";
import Modal from "../../modules/UserModal";
import { commonErrorMessage } from "modules/constant";
import NoteList from "./note-content/noteList";
import PAGE from "modules/router/page";

export function ApsListPage(props: RouteComponentProps) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [invoices, setInvoices] = React.useState<any[]>([]);
  const [errMessage, setErrMessage] = React.useState<string>("");

  const getInvoices = async (token: string) => {
    const formDataJson = {
      token: token,
    }
    try {
      const resp = await fetch(`${APSAPI}/get-letters`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ formDataJson: formDataJson }),
      });

      const respData = await resp.json();
      if (respData.status === "SUCCESS") {
        return respData.formDataJson;
      } else {
        return [];
      }
    } catch (err) {
      setErrMessage(commonErrorMessage);
      return [];
    }
  };

  const handleCloseModal = () => {
    setErrMessage("");
    props.history.goBack();
  };

  React.useEffect(() => {
    const init = async (token: string | null) => {

      if (!token) {
        props.history.push(`${PAGE.APS_HOME}`)
        return;
      }
      const list = await getInvoices(token);
      setInvoices(list);
      setLoading(false);
    };

    const token = localStorage.getItem("token") || null;
    init(token);

    // eslint-disable-next-line
  }, []);

  return (
    <MainView>
      <section className={classes.wrapper}>
        <div className={classes.bgGrey}></div>
        <div className={classes.mainContent}>
          {loading ? (
            <div className={classes.initLoading}>
              <CircularProgress size={80} />
            </div>
          ) : invoices.length ? (
            <Grid container>
              <Grid item xs={12} md={11}>
                <LeftContentInvoicesList title='Danh sách Thông báo tình trạng hợp đồng bảo hiểm' />
                <RigthContentInvoicesList invoices={invoices} />
              </Grid>
              <div className={classes.note}>
                <p><strong>Lưu ý:</strong></p>
                <p>Mật khẩu mở tệp:</p>
                <p><strong>Bên mua bảo hiểm là Cá nhân:</strong> Vui lòng nhập mật khẩu là 8 số ngày tháng năm sinh của Quý khách (Ví dụ: Sinh nhật của Quý Khách là ngày 18 tháng 09 năm 1989 thì mật khẩu là 18091989). Trường hợp khách hàng chỉ có năm sinh thì giá trị ngày/tháng mặc định là 01.</p>
                <p><strong>Bên mua bảo hiểm là Doanh nghiệp:</strong> Vui lòng nhập mật khẩu là Mã số thuế của Doanh nghiệp.</p>
              </div>
            </Grid>

          ) : (
            <div className={classes.noData}>Không có dữ liệu</div>
          )}
        </div>
        <div className={classes.mainContent}>
          {loading ? (
            <div className={classes.initLoading}>
              <CircularProgress size={80} />
            </div>
          ) : invoices.length ? (
            <Grid container>
              <Grid item xs={12} md={11}>
                <LeftContentInvoicesList title='Báo cáo thường niên' />
                <NoteList invoices={invoices} />
              </Grid>
            </Grid>
          ) : (
            <div className={classes.noData}>Không có dữ liệu</div>
          )}
        </div>
      </section>
      <Modal
        title="Thông báo"
        content={errMessage}
        titleSubmit="Thoát"
        open={errMessage ? true : false}
        handleSubmit={handleCloseModal}
      />
    </MainView >
  );
}
